import { useParams } from 'react-router';
import { useApiRead } from 'api-read-hook';
import { Api } from '../../api';
import { ScreenError, SoloLoading } from '../../components';
import ChatDetailLoaded from './ChatDetailLoaded';
import { Model } from '../../models';
import type { HydraCollection } from '../../types';

export default function ChatActiveDetail() {
  const { userId } = useParams();

  const activeApi = Api.ChatConversation.useReadCollectionClinicianactive({
    staleWhileInvalidated: true,
    invalidateAge: 3 * 60,
  });

  const userChat = Model.Chat.findChatByUserId(activeApi.data?.member, userId);

  const conversationId = userChat?.conversation?.id;

  const messagesApi = useApiRead<
    HydraCollection<Api.ChatMessage.V_ChatConversationSub>
  >(conversationId ? `/chat-conversations/${conversationId}/messages` : null, {
    staleWhileInvalidated: true,
    invalidateAge: 3 * 60,
  });

  if (activeApi.error) return <ScreenError {...activeApi} />;
  if (messagesApi.error) return <ScreenError {...messagesApi} />;

  if (!activeApi.data || (conversationId && !messagesApi.data)) {
    return <SoloLoading />;
  }

  const user = userChat?.user || null;

  return (
    <ChatDetailLoaded
      messagesApi={messagesApi}
      chatsApi={activeApi}
      user={user}
      team={null}
      chatType="active"
      userId={userId}
      teamId={undefined}
      entityType={undefined}
    />
  );
}
